import React from 'react';
import { PsychAppointmentBookingSourceFromString } from '@uplift/api';
import { ProviderMedicalRole } from '@uplift/types';
import { ContextualNavigationLayout } from '@uplift/ui-v2';
import { useRouterQueryParam } from '@uplift/constants';
import { Redirect } from 'react-router';
import { FindPsychiatristPage } from './find-psychiatrist.page';
import { useUserMatchesQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';
import { Loading } from '@uplift/pages';


export const CheckForPsychMatch: React.VFC = () => {
  const me = useCurrentuser();
  const sourceKey = useRouterQueryParam('source');
  const { data: matches, isLoading } = useUserMatchesQuery(me.id);
  const source = PsychAppointmentBookingSourceFromString[sourceKey];

  if (isLoading) {
    return (
      <ContextualNavigationLayout>
        <Loading />
      </ContextualNavigationLayout>
    );
  }

  const hasPsychiatrist = matches.activeMatches?.find(x => x.provider.medicalRole === ProviderMedicalRole.psychiatrist);

  if (hasPsychiatrist) {
    return <Redirect to="/main" />;
  }

  return <FindPsychiatristPage source={source} />;
};
